import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useReserhubAccount } from '@/context/ReserhubAccount';
import { clearCdsPointsAttempt } from 'utils/purchase/cdsPointsRecovery';

/** Clear recovery data only after the owner’s purchase completes. */
export default function CdsPointsBalance({ token, usesCdsPoints, purchaseStatus, accountId }) {
  const { user } = useReserhubAccount();
  const completed = usesCdsPoints === true && purchaseStatus === 'completed';
  const ownsPurchase = accountId != null && String(accountId) === String(user?.id);
  useEffect(() => {
    if (completed && ownsPurchase && user?.sessionToken) clearCdsPointsAttempt(token, user.id);
  }, [completed, ownsPurchase, token, user?.id, user?.sessionToken]);
  return null;
}
CdsPointsBalance.propTypes = {
  token: PropTypes.string.isRequired,
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  usesCdsPoints: PropTypes.bool,
  purchaseStatus: PropTypes.string,
};
CdsPointsBalance.defaultProps = {
  accountId: undefined,
  usesCdsPoints: false,
  purchaseStatus: undefined,
};
